<template>
  <div class="article" :class="{vertical: config.layout == 'vertical'}">
    <div class="article-list-title" :class="{ line: config.topLine }">
      <h3 class="list-title-txt" :class="{ bold: config.bold }" v-if="config.title">
        {{ config.title }}
      </h3>
      <div class="list-more" v-if="config.more && config.more.title && config.layout != 'vertical'">
        <div class="list-more-txt">{{ config.more.title }}</div>
        <a-icon type="right" />
      </div>
    </div>
    <ul class="article-list">
      <li
        class="article-item"
        :style="contentStyle"
        v-for="(a, i) in config.list"
        :key="i"
      >
        <div
          class="article-img"
          :style="{ backgroundImage: `url(${a.img || ''})` }"
        ></div>
        <div class="article-txt">
          <h3 class="article-title two-ellipsis">{{ a.title || a.detail.title }}</h3>
          <div class="article-desc two-ellipsis">
            {{ a.desc || (a.detail && a.detail.desc) }}
          </div>
        </div>
      </li>
    </ul>
    <div class="list-more" v-if="config.more && config.more.title && config.layout == 'vertical'">
      <div class="list-more-txt">{{ config.more.title }}</div>
      <a-icon type="right" class="list-more-icon" />
    </div>
  </div>
</template>

<script>
import { getDistance } from "../../common/js/tool";

export default {
  name: "article-list",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    contentStyle() {
      let content = this.config.content;
      let style = {};
      if (content.padding) {
        style.padding = getDistance(content.padding);
      }
      if (content.borderRadius) {
        style.borderRadius = content.borderRadius + "px";
      }
      if (content.backgroundColor) {
        style.backgroundColor = content.backgroundColor;
      }
      return style;
    },
  },
};
</script>

<style scoped lang="less">
.article {
  --border-color: #dcdfe6;
  --border: 1px solid var(--border-color);
  --light-font-color: #c0c4cc;
  --tip-font-color: #909399;
  --back-light-color: #eee;
  &.vertical {
    .list-more {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .list-more-icon {
      transform: rotate(90deg);
    }
  }
}
.article-list {
  padding: 10px 0;
}
.article-list-title {
  display: flex;
  align-items: center;
  &.line {
    border-bottom: var(--border);
  }
}
.list-title-txt {
  margin: 0;
  flex: 1;
  height: 36px;
  line-height: 36px;
  &.bold {
    font-weight: 600;
  }
}
.list-more {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--light-font-color);
}
.article-item {
  display: flex;
  padding: 10px 0;
  &.line:not(:last-of-type) {
    border-bottom: var(--border);
  }
  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
}
.article-txt {
  flex: 1;
}
.article-title {
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
}
.article-desc {
  margin-top: 12px;
  color: var(--tip-font-color);
  line-height: 1.4;
}
.article-img {
  flex-shrink: 0;
  margin-right: 10px;
  width: 90px;
  height: 90px;
  //   background: var(--back-light-color) center no-repeat;
  background: center no-repeat;
  background-size: cover;
  border-radius: 8px;
}
</style>
